import { LoadingButton } from '@mui/lab'
import { Stack } from '@mui/material'
import AppleIcon from '@mui/icons-material/Apple'
import MicrosoftIcon from '@mui/icons-material/Microsoft'

import { useDmpConnectDownloadBuild } from '../model/useDmpConnectDownloadBuild'

export function DownloadButtons() {
  const { download, isDownloadingMacOSBuild, isDownloadingWindowsBuild } = useDmpConnectDownloadBuild()

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
      <LoadingButton loading={isDownloadingMacOSBuild} onClick={() => download('macos')} variant="contained">
        <AppleIcon />
      </LoadingButton>
      <LoadingButton loading={isDownloadingWindowsBuild} onClick={() => download('windows')} variant="contained">
        <MicrosoftIcon />
      </LoadingButton>
    </Stack>
  )
}
